<template>
  <div @click.stop="onClick" class="nx-btn-sort" :class="`text-${color}`">
    <i
      :key="localValue"
      class="fas"
      :class="[sortClass, sizeClass]"
    />
  </div>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

import {
  SORT_TYPE_ASC,
  SORT_TYPE_DESC,
  SORT_TYPE_NONE } from '../../constants/sorts'

const reactiveValueMixin = useReactiveModelMixin(
  'value',
  {
    type: String,
    default: SORT_TYPE_NONE,
    required: false
  })

export default {
  name: 'ScSortButton',
  mixins: [
    reactiveValueMixin
  ],
  props: {
    color: {
      type: String,
      default: 'light',
      required: false
    },
    size: {
      type: String,
      default: 'default',
      required: false
    }
  },
  computed: {
    hasSize () {
      return this.size === 'lg' || this.size === 'xs' || this.size === 'sm'
    },
    sizeClass () {
      if (this.hasSize) {
        return `fa-${this.size}`
      }

      return undefined
    },
    sortClass () {
      switch (this.localValue) {
        case SORT_TYPE_ASC:
          return 'fa-sort-up'
        case SORT_TYPE_DESC:
          return 'fa-sort-down'
        default:
          return 'fa-sort'
      }
    }
  },
  methods: {
    onClick () {
      switch (this.localValue) {
        case SORT_TYPE_NONE:
          this.localValue = SORT_TYPE_ASC
          break
        case SORT_TYPE_ASC:
          this.localValue = SORT_TYPE_DESC
          break
        case SORT_TYPE_DESC:
          this.localValue = SORT_TYPE_NONE
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/buttons/NxSortButton.vue